import * as React from 'react';
import { isEmpty } from 'lodash';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { CollapsibleItem } from './CollapsibleItem';
type LineSubItem = {
  title: string;
  price: string;
};
type Props = {
  title: string;
  price?: string;
  index: number;
  icon?: IconName;
  color?: string;
  isHomeDetails?: boolean;
  subItems?: Array<LineSubItem>;
  titleClassName?: string;
  details?: React.ReactNode;
};
export const PaidServicesListItem = ({
  color,
  isHomeDetails,
  index,
  icon,
  title,
  titleClassName,
  subItems,
  price,
  details,
}: Props) => {
  const subContent = !isEmpty(subItems) ? (
    <React.Fragment>
      {subItems.map((subItem) => (
        <div key={subItem.title} className="mt-5 flex items-center">
          <div className="text-14">{subItem.title}</div>
          <div className="ms-auto whitespace-nowrap font-bold capitalize text-black">
            {subItem.price}
          </div>
        </div>
      ))}
    </React.Fragment>
  ) : null;
  return (
    <CollapsibleItem
      title={title}
      details={details}
      subContent={subContent}
      contentClassName={isHomeDetails ? 'text-12' : 'text-16'}
      additionalClass={classnames(
        {
          'border-t-1 border-dashed border-grey': index !== 0,
        },
        {
          'py-10': isHomeDetails,
        },
        {
          'py-15': !isHomeDetails,
        },
      )}
    >
      <div className={classnames('flex w-full items-start', color)}>
        <p className={classnames('flex items-start gap-10', titleClassName)}>
          <Icon name={icon} className="shrink-0" width="1.5625rem" />
          {title}
        </p>
        <div
          className={classnames('ms-auto whitespace-nowrap font-bold capitalize text-black', color)}
        >
          {price}
        </div>
      </div>
    </CollapsibleItem>
  );
};
